import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFifaComponent } from './simple-icons-fifa.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFifaComponent ],
    exports:      [ SimpleIconsFifaComponent ],
    bootstrap:    []
})
export class SimpleIconsFifaModule {}
